import {UC_DASHBOARD} from 'app/user-change/user-change-routing-roots';
import {ItemMenu} from '@shared/models/item-menu.model';
import {ROOT_ADMINISTRATION, ROOT_ADMINISTRATION_USER_MANAGEMENT, ROOT_MOBILITY, ROOT_CARGOS} from '@app/app-routing-roots';
import {
	FIND_CENTERS_DASHBOARD,
	ROOT_ADMINISTRATION_CHANNELING,
	ROOT_ADMINISTRATION_RULES,
	ROOT_AUTHORITY,
	ROOT_BOOKINGS_PRELEASE,
	ROOT_BOOKINGS_RELIEF,
	ROOT_CLAIMS_ADMIN,
	ROOT_CLAIMS_COMPLAINT,
	ROOT_CLAIMS_OLSA,
	ROOT_CLAIMS_PRACTICE_CAR,
	ROOT_CLAIMS_PRACTICES,
	ROOT_CLAIMS_REPAIR,
	ROOT_CLAIMS_SUPERVISOR,
	ROOT_CLAIMS_THEFT,
	ROOT_CONTRACT_CLOSING_ALD,
	ROOT_CONTRACT_CLOSING_DK_BO,
	ROOT_CONTRACT_CLOSING_DK_C,
	ROOT_CONTRACT_CLOSING_DK_OP,
	ROOT_CONTRACT_CLOSING_SP,
	ROOT_DELIVERY,
	ROOT_DELIVERY_ASR,
	ROOT_FLOTTA_POOL,
	ROOT_INVOICING,
	ROOT_LOGISTICS,
	ROOT_PROFILE,
	ROOT_TYRES,
	ROOT_USER_CHANGE_ALD,
	ROOT_USER_CHANGE_SP
} from '../../app-routing-roots';
import {DL_DASHBOARD} from '../../delivery/delivery-routing-roots';
import {CCSPO_DASHBOARD} from '@cc-sp-operator/cc-sp-routing-roots';
import {CCDKO_DASHBOARD} from '@cc-dekra-operator/cc-dk-o-routing-roots';
import {CCALD_DASHBOARD} from '@cc-ald-operator/cc-ald-o-routing-roots';
import {CCDKC_DASHBOARD} from '@cc-dekra/cc-dk-routing-roots';
import {CCDKBO_DASHBOARD} from '@cc-dekra-backoffice/cc-dk-bo-routing-roots';
import {CLAIMS_ADMIN_DASHBOARD} from 'app/claims/claims-admin/claims-admin-routing-roots';
import {CLAIMS_SUPERVISOR_DASHBOARD} from 'app/claims/claims-supervisor/claims-supervisor-routing-roots';
import {CLAIMS_LIST, CLAIMS_PRACTICE_LIST} from 'app/claims/claims-commons/claims-commons-routing-roots';
import {CLAIMS_PRACTICE_CAR_LIST} from '../../claims/claims-practice-car/claims-practice-car-roots';
import {CLAIM_LIST} from '../../claims/claims-olsa/claims-olsa-routing-roots';
import {INVOICING_DASHBOARD} from '../../invoicing/invoicing-routing-roots';
import {TYRES_OPA, TYRES_OPC, TYRES_OPF, TYRES_OPS} from '../../tyres/tyres-routing-roots';
import {TYRES_OPC_DASHBOARD} from '../../tyres/opc/tyres-opc-routing-roots';
import {TYRES_OPA_DASHBOARD} from '../../tyres/opa/tyres-opa-routing-roots';
import {TYRES_OPF_DASHBOARD} from '../../tyres/opf/tyres-opf-routing-roots';
import {TYRES_OPS_DASHBOARD} from '../../tyres/ops/tyres-ops-routing-roots';
import {LOGISTICS_OPAD, LOGISTICS_OPASR, LOGISTICS_OPC, LOGISTICS_OPL} from '../../logistics/logistics-routing-roots';
import {ADMINISTRATION_RULES} from '../../administration/administration-rules/administration-rules-routing-roots';
import {LOGISTICS_OPC_TRANSFER} from '../../logistics/opc/logistics-opc-routing-roots';
import {FlottaPoolRoutingRoots} from '../../flotta-pool/flotta-pool-routing-roots';

import {ADMINISTRATION_USER, ADMINISTRATION_USER_DASHBOARD} from '../../administration/administration-user-management/administration-users-routing-roots';
import {ADMINISTRATION_DASHBOARD} from '../../administration/administration-channeling/administration-channeling-routing-roots';
import {BookingsRoutingRoots} from 'app/bookings/bookings-routing-roots';
import { NEMO_MOBILITY_AUTHORITY_BACKOFFICE } from '@app/permissions-variables';
import { MOBILITY_BACKOFFICE_STATIC } from '@app/mobility/mobility-roots';
import { NemoModuleKeys, ProfilePermissionModel } from '@shared/models/user-permission.model';
import { UserV3Model } from '@shared/models/user-v-3.model';
import { AUTHORITY_DOSSIER_WORKING_LIST, AUTHORITY_QUOTATIONS_LIST } from '@app/authority/authority-routing-roots';
import { DL_CARGOS_LIST } from 'app/cargos/cargos-routing-roots';

type administrationType = 'ADMINISTRATION_USER_MANAGEMENT' | 'ADMINISTRATION_RULES' | 'ADMINISTRATION_CHANNELING';
export class UserUtilitiesModel {
	static getDeliveryItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_DELIVERY,
			routerLink: '/' + ROOT_DELIVERY + '/' + DL_DASHBOARD,
			icon: 'amd-icon--font amd-icon--consegna-32x32',
			module_key: NemoModuleKeys.DELIVERY,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getSUDeliveryItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_DELIVERY,
			routerLink: '/' + ROOT_DELIVERY + '/' + FIND_CENTERS_DASHBOARD,
			icon: 'amd-icon--font amd-icon--consegna-32x32',
			module_key: NemoModuleKeys.DELIVERY,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getDeliveryASRItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_DELIVERY_ASR,
			routerLink: '/' + ROOT_DELIVERY_ASR + '/' + DL_DASHBOARD,
			icon: 'amd-icon--font amd-icon--consegna-32x32',
			module_key: NemoModuleKeys.DELIVERY,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getCargosItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_CARGOS,
			routerLink: '/' + ROOT_CARGOS + '/' + DL_CARGOS_LIST,
			icon: 'amd-icon--cargos_32x32',
			module_key: NemoModuleKeys.CARGOS,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getCCSPOItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_CONTRACT_CLOSING_SP,
			routerLink: '/' + ROOT_CONTRACT_CLOSING_SP + '/' + CCSPO_DASHBOARD,
			icon: 'amd-icon--font amd-icon--riconsegna-32x32',
			module_key: NemoModuleKeys.CONTRACT_CLOSING_,
			profile_key: profile_key,
			profile_name: profile_name
		});

	}

	static getCCSPOSUItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_CONTRACT_CLOSING_SP,
			routerLink: '/' + ROOT_CONTRACT_CLOSING_SP + '/' + FIND_CENTERS_DASHBOARD,
			icon: 'amd-icon--font amd-icon--riconsegna-32x32',
			module_key: NemoModuleKeys.CONTRACT_CLOSING_,
			profile_key: profile_key,
			profile_name: profile_name
		});

	}

	static getCCDKOItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_CONTRACT_CLOSING_DK_OP,
			routerLink:
				'/' + ROOT_CONTRACT_CLOSING_DK_OP + '/' + CCDKO_DASHBOARD,
			icon: 'amd-icon--font amd-icon--riconsegna-32x32',
			module_key: NemoModuleKeys.CONTRACT_CLOSING_,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getCCDKCItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_CONTRACT_CLOSING_DK_C,
			routerLink:
				'/' + ROOT_CONTRACT_CLOSING_DK_C + '/' + CCDKC_DASHBOARD,
			icon: 'amd-icon--font amd-icon--riconsegna-32x32',
			module_key: NemoModuleKeys.CONTRACT_CLOSING_,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getCCALDItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_CONTRACT_CLOSING_ALD,
			routerLink: '/' + ROOT_CONTRACT_CLOSING_ALD + '/' + CCALD_DASHBOARD,
			icon: 'amd-icon--font amd-icon--riconsegna-32x32',
			module_key: NemoModuleKeys.CONTRACT_CLOSING_,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getCCBOItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_CONTRACT_CLOSING_DK_BO,
			routerLink:
				'/' + ROOT_CONTRACT_CLOSING_DK_BO + '/' + CCDKBO_DASHBOARD,
			icon: 'amd-icon--font amd-icon--riconsegna-32x32',
			module_key: NemoModuleKeys.CONTRACT_CLOSING_,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getClaimsAdminItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_CLAIMS_ADMIN,
			routerLink: '/' + ROOT_CLAIMS_ADMIN + '/' + CLAIMS_ADMIN_DASHBOARD,
			icon: 'amd-icon--font amd-icon--veicoli-sinistri-24x24',
			module_key: NemoModuleKeys.CLAIMS,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getClaimsTheftItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_CLAIMS_THEFT,
			routerLink: '/' + ROOT_CLAIMS_THEFT,
			icon: 'amd-icon--font amd-icon--veicoli-sinistri-24x24',
			module_key: NemoModuleKeys.CLAIMS,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getClaimsSupervisorItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_CLAIMS_SUPERVISOR,
			routerLink: '/' + ROOT_CLAIMS_SUPERVISOR + '/' + CLAIMS_SUPERVISOR_DASHBOARD,
			icon: 'amd-icon--font amd-icon--veicoli-sinistri-24x24',
			module_key: NemoModuleKeys.CLAIMS,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getClaimsOlsaItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_CLAIMS_OLSA,
			routerLink: '/' + ROOT_CLAIMS_OLSA + '/' + CLAIM_LIST,
			icon: 'amd-icon--font amd-icon--veicoli-sinistri-24x24',
			module_key: NemoModuleKeys.CLAIMS,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getClaimsRepairItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_CLAIMS_REPAIR,
			routerLink: '/' + ROOT_CLAIMS_REPAIR + '/' + CLAIMS_LIST,
			icon: 'amd-icon--font amd-icon--veicoli-sinistri-24x24',
			module_key: NemoModuleKeys.CLAIMS,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getClaimsPracticeCarItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_CLAIMS_PRACTICE_CAR,
			routerLink: '/' + ROOT_CLAIMS_PRACTICE_CAR + '/' + CLAIMS_PRACTICE_CAR_LIST,
			icon: 'amd-icon--font amd-icon--veicoli-sinistri-24x24',
			module_key: NemoModuleKeys.CLAIMS,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getClaimsPracticesItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_CLAIMS_PRACTICE_CAR,
			routerLink: '/' + ROOT_CLAIMS_PRACTICES + '/' + CLAIMS_PRACTICE_LIST,
			icon: 'amd-icon--font amd-icon--veicoli-sinistri-24x24',
			module_key: NemoModuleKeys.CLAIMS,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getClaimsComplaintItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_CLAIMS_OLSA,
			routerLink: '/' + ROOT_CLAIMS_COMPLAINT + '/' + CLAIMS_LIST,
			icon: 'amd-icon--font amd-icon--veicoli-sinistri-24x24',
			module_key: NemoModuleKeys.CLAIMS,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getNotificationCenterItemMenu(id: string): ItemMenu {
		return new ItemMenu({
			id: id,
			name: 'notification-center',
			routerLink: '/notification-center/dashboard',
			icon: 'amd-icon--font amd-icon--alert-32x32',
			module_key: NemoModuleKeys.NOTIFICATION_CENTER,
			profile_key: '',
		});
	}

	static getProfileItemMenu(id: string): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_PROFILE,
			routerLink: '/' + ROOT_PROFILE,
			icon: 'amd-icon--font amd-icon--profilo-centro-32x32',
			// module_key: NemoModuleKeys.PROFILE,
			// profile_key: '',
			isPrimary: true
		});
	}

	static getAuthorityItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_AUTHORITY,
			routerLink: '/' + ROOT_AUTHORITY + '/dashboard/' + AUTHORITY_DOSSIER_WORKING_LIST,
			icon: 'amd-icon--font amd-icon--manutenzioni-24x24',
			module_key: NemoModuleKeys.AUTHORITY,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getAuthorityDealerItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_AUTHORITY,
			routerLink: '/' + ROOT_AUTHORITY + '/dashboard/' +AUTHORITY_QUOTATIONS_LIST,
			icon: 'amd-icon--font amd-icon--manutenzioni-24x24',
			module_key: NemoModuleKeys.AUTHORITY,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getMobilityItemMenu(id: string, profile_key: string, profile_name): ItemMenu {

		// I profili backoffice di Mobility hanno una landing page statica a parte
		let newLink = '/' + ROOT_MOBILITY;
		
		if (NEMO_MOBILITY_AUTHORITY_BACKOFFICE.includes(profile_key)) {
			newLink += '/' + MOBILITY_BACKOFFICE_STATIC;
		}

		return new ItemMenu({
			id: id,
			name: ROOT_MOBILITY,
			routerLink: newLink,

			// non viene presa da assets/icons/icons-sprite.png (dentro _iconfont.scss)
			// TODO
			// bisogna creare una classe CSS come per le altre icone
			icon: '/assets/icons/body-repair.svg',
			module_key: NemoModuleKeys.MOBILITY,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getAuthoritySUItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_AUTHORITY,
			routerLink: '/' + ROOT_AUTHORITY + '/' + FIND_CENTERS_DASHBOARD,
			icon: 'amd-icon--font amd-icon--manutenzioni-24x24',
			module_key: NemoModuleKeys.AUTHORITY,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getInvoicingItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_INVOICING,
			routerLink: '/' + ROOT_INVOICING + '/' + INVOICING_DASHBOARD,
			icon: 'amd-icon--font amd-icon--fatturazione_32x32',
			module_key: NemoModuleKeys.INVOICING,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getInvoicingSUItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_INVOICING,
			routerLink: '/' + ROOT_INVOICING + '/' + FIND_CENTERS_DASHBOARD,
			icon: 'amd-icon--font amd-icon--fatturazione_32x32',
			module_key: NemoModuleKeys.INVOICING,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}


	static getTyresItemMenuOpc(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_TYRES,
			routerLink: `/${ROOT_TYRES}/${TYRES_OPC}/${TYRES_OPC_DASHBOARD}`,
			icon: 'amd-icon--font amd-icon--ruote-standard-24x24',
			module_key: NemoModuleKeys.TYRES,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getTyresSUItemMenuOpc(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_TYRES,
			routerLink: `/${ROOT_TYRES}/${TYRES_OPC}/${FIND_CENTERS_DASHBOARD}`,
			icon: 'amd-icon--font amd-icon--ruote-standard-24x24',
			module_key: NemoModuleKeys.TYRES,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getTyresItemMenuOpa(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_TYRES,
			routerLink: `/${ROOT_TYRES}/${TYRES_OPA}/${TYRES_OPA_DASHBOARD}`,
			icon: 'amd-icon--font amd-icon--ruote-standard-24x24',
			module_key: NemoModuleKeys.TYRES,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getTyresItemMenuOpf(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_TYRES,
			routerLink: `/${ROOT_TYRES}/${TYRES_OPF}/${TYRES_OPF_DASHBOARD}`,
			icon: 'amd-icon--font amd-icon--ruote-standard-24x24',
			module_key: NemoModuleKeys.TYRES,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getTyresItemMenuOps(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_TYRES,
			routerLink: `/${ROOT_TYRES}/${TYRES_OPS}/${TYRES_OPS_DASHBOARD}`,
			icon: 'amd-icon--font amd-icon--ruote-standard-24x24',
			module_key: NemoModuleKeys.TYRES,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getUCALDItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_USER_CHANGE_ALD,
			routerLink: '/' + ROOT_USER_CHANGE_ALD + '/' + UC_DASHBOARD,
			icon: 'amd-icon--font amd-icon--change-user_32x32',
			module_key: NemoModuleKeys.USER_CHNAGE_,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getUCSPItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_USER_CHANGE_SP,
			routerLink: '/' + ROOT_USER_CHANGE_SP + '/' + UC_DASHBOARD,
			icon: 'amd-icon--font amd-icon--change-user_32x32',
			module_key: NemoModuleKeys.USER_CHNAGE_,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getUCSPSUItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		//if (o.isCenterOperator(NemoModuleKeys.USER_CHNAGE_) || o.isCenterOperator(NemoModuleKeys.USER_CHNAGE)) {
		return new ItemMenu({
			id: id,
			name: ROOT_USER_CHANGE_SP,
			routerLink: '/' + ROOT_USER_CHANGE_SP + '/' + FIND_CENTERS_DASHBOARD,
			icon: 'amd-icon--font amd-icon--change-user_32x32',
			module_key: NemoModuleKeys.USER_CHNAGE_,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getLogisticsItemMenuOpl(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_LOGISTICS,
			routerLink: '/' + ROOT_LOGISTICS + '/' + LOGISTICS_OPL,
			icon: 'amd-icon--font amd-icon--pushpin-24x242',
			module_key: NemoModuleKeys.LOGISTICS,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getLogisticsItemMenuOpad(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_LOGISTICS,
			routerLink: '/' + ROOT_LOGISTICS + '/' + LOGISTICS_OPAD,
			icon: 'amd-icon--font amd-icon--pushpin-24x242',
			module_key: NemoModuleKeys.LOGISTICS,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getLogisticsItemMenuOpas(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_LOGISTICS,
			routerLink: '/' + ROOT_LOGISTICS + '/' + LOGISTICS_OPASR,
			icon: 'amd-icon--font amd-icon--pushpin-24x242',
			module_key: NemoModuleKeys.LOGISTICS,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getLogisticsItemMenuSU(id: string, profile_key: string, profile_name): ItemMenu {
		//if (o.isCenterOperator(NemoModuleKeys.LOGISTICS)) {
		return new ItemMenu({
			id: id,
			name: ROOT_LOGISTICS,
			routerLink: '/' + ROOT_LOGISTICS + '/' + LOGISTICS_OPASR + '/' + FIND_CENTERS_DASHBOARD,
			icon: 'amd-icon--font amd-icon--pushpin-24x242',
			module_key: NemoModuleKeys.LOGISTICS,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getLogisticsItemMenuOpc(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_LOGISTICS,
			routerLink: '/' + ROOT_LOGISTICS + '/' + LOGISTICS_OPC + '/' + LOGISTICS_OPC_TRANSFER,
			icon: 'amd-icon--font amd-icon--pushpin-24x242',
			module_key: NemoModuleKeys.LOGISTICS,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getFlottaPoolItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_FLOTTA_POOL,
			routerLink: '/' + ROOT_FLOTTA_POOL,
			icon: 'amd-icon--font amd-icon--auto-32x32',
			module_key: NemoModuleKeys.FLOTTA_POOL,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getFlottaPoolSUItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_FLOTTA_POOL,
			routerLink: '/' + ROOT_FLOTTA_POOL + '/' + FIND_CENTERS_DASHBOARD,
			icon: 'amd-icon--font amd-icon--auto-32x32',
			module_key: NemoModuleKeys.FLOTTA_POOL,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}
	/*
	static getBookingsItemMenu(id: string): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_BOOKINGS,
			routerLink: '/' + ROOT_BOOKINGS,
			icon: 'amd-icon--font amd-icon--auto-32x32',
			module_key: NemoModuleKeys.BOOKINGS,
			profile_key: '',
		});
	}
	*/

	static getBookingSUItemMenuRelief(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_BOOKINGS_RELIEF,
			routerLink: '/' + ROOT_BOOKINGS_RELIEF + '/' + FIND_CENTERS_DASHBOARD,
			icon: 'amd-icon--font amd-icon--relief_32x32',
			module_key: NemoModuleKeys.BOOKINGS_RELIEF,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getBookingItemMenuRelief(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_BOOKINGS_RELIEF,
			routerLink: '/' + ROOT_BOOKINGS_RELIEF + '/' + BookingsRoutingRoots.RESERVATION_LIST,
			icon: 'amd-icon--font amd-icon--relief_32x32',
			module_key: NemoModuleKeys.BOOKINGS_RELIEF,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getBookingItemMenuPrelease(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_BOOKINGS_PRELEASE,
			routerLink: '/' + ROOT_BOOKINGS_PRELEASE + '/' +  BookingsRoutingRoots.RESERVATION_LIST,
			icon: 'amd-icon--font amd-icon--prelease_32x32',
			module_key: NemoModuleKeys.BOOKINGS_PRELEASE,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getBookingItemMenuReliefDashBoard(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_BOOKINGS_RELIEF,
			routerLink: '/' + ROOT_BOOKINGS_RELIEF + '/' + BookingsRoutingRoots.DASHBOARD,
			icon: 'amd-icon--font amd-icon--relief_32x32',
			module_key: NemoModuleKeys.BOOKINGS_RELIEF,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	static getBookingItemMenuPreleaseDashBoard(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_BOOKINGS_PRELEASE,
			routerLink: '/' + ROOT_BOOKINGS_PRELEASE + '/' + BookingsRoutingRoots.DASHBOARD,
			icon: 'amd-icon--font amd-icon--prelease_32x32',
			module_key: NemoModuleKeys.BOOKINGS_PRELEASE,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}


/*
	static getBookingItemMenuPrelease(id: string, can_view_dashboard: boolean, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_BOOKINGS_PRELEASE,
			routerLink: '/' + ROOT_BOOKINGS_PRELEASE + '/' + (can_view_dashboard ? BookingsRoutingRoots.DASHBOARD : BookingsRoutingRoots.RESERVATION_LIST),
			icon: 'amd-icon--font amd-icon--prelease_32x32',
			module_key: NemoModuleKeys.BOOKINGS_PRELEASE,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}
*/
	static getFlottaPoolItemMenuOperator(id: string, profile_key: string, profile_name): ItemMenu {
		return new ItemMenu({
			id: id,
			name: ROOT_FLOTTA_POOL,
			routerLink: '/' + ROOT_FLOTTA_POOL + '/' + FlottaPoolRoutingRoots.DASHBOARD + '/' + FlottaPoolRoutingRoots.VEHICLES,
			icon: 'amd-icon--font amd-icon--auto-32x32',
			module_key: NemoModuleKeys.FLOTTA_POOL,
			profile_key: profile_key,
			profile_name: profile_name
		});
	}

	// static getAdministrationUserManagementItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
	// 	return new ItemMenu({
	// 		id: id,
	// 		name: ROOT_ADMINISTRATION_USER_MANAGEMENT,
	// 		routerLink: '/' + ROOT_ADMINISTRATION_USER_MANAGEMENT + '/' + ADMINISTRATION_USER_DASHBOARD,
	// 		icon: 'amd-icon--font amd-icon--user_32x32',
	// 		module_key: NemoModuleKeys.ADMINISTRATION,
	// 		profile_key: profile_key,
	// 		profile_name: profile_name
	// 	});
	// }
	// static getAdministrationItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
	// 	return new ItemMenu({
	// 		id: id,
	// 		name: ROOT_ADMINISTRATION,
	// 		routerLink: '/' + ROOT_ADMINISTRATION,
	// 		icon: 'amd-icon--font amd-icon--user_32x32',
	// 		module_key: NemoModuleKeys.ADMINISTRATION,
	// 		profile_key: profile_key,
	// 		profile_name: profile_name
	// 	});
	// }

	// static getAdministrationChannelingItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
	// 	return new ItemMenu({
	// 		id: id,
	// 		name: ROOT_ADMINISTRATION_CHANNELING,
	// 		routerLink: '/' + ROOT_ADMINISTRATION_CHANNELING + '/' + ADMINISTRATION_DASHBOARD,
	// 		icon: 'amd-icon--font amd-icon--user_32x32',
	// 		module_key: NemoModuleKeys.ADMINISTRATION,
	// 		profile_key: profile_key,
	// 		profile_name: profile_name
	// 	});
	// }
	
	// static getAdministrationRulesItemMenu(id: string, profile_key: string, profile_name): ItemMenu {
	// 	return new ItemMenu({
	// 		id: id,
	// 		name: ROOT_ADMINISTRATION_RULES,
	// 		routerLink: '/' + ROOT_ADMINISTRATION_RULES + '/' + ADMINISTRATION_RULES,
	// 		icon: 'amd-icon--font amd-icon--user_32x32',
	// 		module_key: NemoModuleKeys.ADMINISTRATION,
	// 		profile_key: profile_key,
	// 		profile_name: profile_name
	// 	});
	// }

	// Refactoring - utilizzando una funzione sola con la logica interna
	static getAdministrationItemMenu(profile: ProfilePermissionModel, type: administrationType): ItemMenu {

		let item = {
			id					 : UserV3Model.ADMINISTRATION_MENU_ID,
			icon				 : 'amd-icon--font amd-icon--user_32x32',
			module_key	 : '',
			profile_key	 : profile.key,
			profile_name : profile.name,
			name				 : '',
			routerLink	 : '',
		};

		// Non trovo il corrispettivo
		// if (.includes(profile.key)) {
		// 	item.name       = ROOT_ADMINISTRATION;
		// 	item.routerLink = '/' + ROOT_ADMINISTRATION	
		// }

		const listener = {
			'ADMINISTRATION_USER_MANAGEMENT' : {
				icon: 'amd-icon--font amd-icon--lavorazioni-cliente_24x24',
				module_key : NemoModuleKeys.ADMINISTRATION_USER_MANAGEMENT,
				name       : ROOT_ADMINISTRATION_USER_MANAGEMENT,
				routerLink : '/' + ROOT_ADMINISTRATION_USER_MANAGEMENT + '/' + ADMINISTRATION_USER,
			},
			'ADMINISTRATION_RULES' : {
				/*module_key : NemoModuleKeys.ADMINISTRATION_RULES,
				name       : ROOT_ADMINISTRATION_RULES, deprecato per unificare i moduli dopo multiprofilo*/
				module_key : NemoModuleKeys.ADMINISTRATION,
				name       : ROOT_ADMINISTRATION,
				routerLink : '/' + ROOT_ADMINISTRATION_RULES + '/' + ADMINISTRATION_RULES,
			},
			'ADMINISTRATION_CHANNELING' : {
				/*module_key : NemoModuleKeys.ADMINISTRATION_CHANNELING,
				name       : ROOT_ADMINISTRATION_CHANNELING, deprecato per unificare i moduli dopo multiprofilo*/
				module_key : NemoModuleKeys.ADMINISTRATION,
				name       : ROOT_ADMINISTRATION,
				routerLink : '/' + ROOT_ADMINISTRATION_CHANNELING + '/' + ADMINISTRATION_DASHBOARD,
			},
		}
		
		return new ItemMenu({...item, ...listener[type]});
	}
}
